import Convert from '../utils/convert';
import Socium from '../constants/Socium';
const validLength = [6, 14, 20];
export const isValidLength = (length, valid) => (valid.indexOf(length) > -1 ? true : false);
export const voucherValidation = value => {
  const voucher = Convert.voucher(value);
  return voucher && isValidLength(voucher.length, validLength)
    ? undefined
    : 'Please enter 6, 14 or 20 digits voucher code.';
};

export const pdateValidation = value =>
  value &&
  value.length == 10 &&
  /^(((((0[1-9])|(1\d)|(2[0-8]))\/((0[1-9])|(1[0-2])))|((31\/((0[13578])|(1[02])))|((29|30)\/((0[1,3-9])|(1[0-2])))))\/((20[0-9][0-9])|(19[0-9][0-9])))|((29\/02\/(19|20)(([02468][048])|([13579][26]))))$/i.test(
    value
  )
    ? undefined
    : 'Please choose a date.';

export const phone = value =>
  value && /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/.test(value)
    ? undefined
    : 'Please provide a valid number';

export const email = value =>
  value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? undefined
    : 'Please provide a valid email address';

export const address = value =>
  value && value.length > 4 ? undefined : 'Please provide a valid address';

export const requiredTrue = value =>
  value && value === true ? undefined : 'Agree and check the box above is required';

export const requiredTrueForQuestion656 = value =>
  value && value === true
    ? undefined
    : "If you are replacing an existing fan then you're able to use the cheaper Fixed price ceiling fan replacement service. Please call us on 1300 043 520 to discuss.";

export const requiredYesForExistingToiletForBunnings = value =>
  value && String(value) === Socium.QUESTION_ANSWER_YES_EXISTING_TOILET_IN_REPLACE_BUNNINGS
    ? undefined
    : 'Your voucher is for a toilet replacement service, select yes if your bathroom has a toilet that will be replaced. If you require a new toilet installation, you can return this voucher and obtain a refund at the store.';
